<template>
    <div ref="root" class="field-fontfamily">
        <div class="field-fontfamily__wrap">
            <div v-bind:class="{ slider: slideView }" class="field-fontfamily__slider">
                <div
                    v-for="(fontfamilies__value, fontfamilies__key) in getFontfamilies"
                    v-bind:key="id + '_' + fontfamilies__value.id"
                    class="field-fontfamily__slide"
                >
                    <template v-if="slideView">
                        <input
                            type="radio"
                            :id="id + '_' + fontfamilies__value.id"
                            disabled
                            :value="fontfamilies__value.id"
                            class="field-fontfamily__input"
                        />
                    </template>
                    <template v-else>
                        <input
                            type="radio"
                            :id="id + '_' + fontfamilies__value.id"
                            v-model="simpleFieldModel"
                            :value="fontfamilies__value.id"
                            class="field-fontfamily__input"
                        />
                    </template>
                    <label
                        v-bind:class="
                            'field-fontfamily__preview field-fontfamily__preview--' +
                                fontfamilies__value.id +
                                ''
                        "
                        :for="id + '_' + fontfamilies__value.id"
                    >
                        <span
                            class="field-fontfamily__num"
                            v-html="'#' + ('000' + fontfamilies__key).slice(-3)"
                        ></span>
                        <span class="field-fontfamily__pseudo-radio"></span>
                        <h2 class="field-fontfamily__preview-title">
                            {{ getProp('deha.user.firma1') }}
                        </h2>
                        <h3 class="field-fontfamily__preview-subtitle">
                            {{ getProp('deha.user.firma1') }}
                        </h3>
                        <p class="field-fontfamily__preview-paragraph">
                            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
                            nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat
                            volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation
                            ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                        </p>
                    </label>
                </div>
            </div>
            <a
                v-if="slideView"
                href="#"
                v-on:click.prevent="prevSlide"
                class="field-fontfamily__arrow field-fontfamily__arrow--prev"
                >Vorheriges Schriftbild</a
            >
            <a
                v-if="slideView"
                href="#"
                v-on:click.prevent="nextSlide"
                class="field-fontfamily__arrow field-fontfamily__arrow--next"
                >Nächstes Schriftbild</a
            >
        </div>
    </div>
</template>

<script>
import Siema from 'siema';
import { mapGetters } from 'vuex';
import pushid from 'pushid';
import { SimpleFieldMixin } from '@/mixins/SimpleFieldMixin';

export default {
    data() {
        return {
            id: pushid(),
            slider: null
        };
    },
    components: {},
    methods: {
        prevSlide() {
            this.slider.prev();
        },
        nextSlide() {
            this.slider.next();
        }
    },
    computed: {
        ...mapGetters(['getFontfamilies', 'getProp'])
    },
    mixins: [SimpleFieldMixin],
    props: {
        slideView: Boolean
    },
    mounted() {
        if (this.$refs.root.querySelector('.slider') !== null) {
            this.slider = new Siema({
                selector: this.$refs.root.querySelector('.slider'),
                duration: 200,
                easing: 'ease-out',
                perPage: 3,
                startIndex: this.simpleFieldGet != '' ? this.simpleFieldGet - 2 : 1,
                draggable: true,
                multipleDrag: false,
                threshold: 20,
                loop: true,
                rtl: false,
                onInit: () => {
                    let index = this.simpleFieldGet != '' ? this.simpleFieldGet : 1;
                    if (this.$refs.root.querySelector('#' + this.id + '_' + index) !== null) {
                        this.$refs.root
                            .querySelectorAll('#' + this.id + '_' + index)
                            .forEach((el) => {
                                el.checked = true;
                            });
                    }
                },
                onChange: () => {
                    let index = this.slider.currentSlide + 2;
                    if (index > 20) {
                        index = index % 20;
                    }
                    if (index === 0) {
                        index = 20;
                    }
                    if (
                        this.$refs.root.querySelector('.field-fontfamily__input:checked') !== null
                    ) {
                        this.$refs.root
                            .querySelectorAll('.field-fontfamily__input:checked')
                            .forEach((el) => {
                                el.checked = false;
                            });
                    }
                    if (this.$refs.root.querySelector('#' + this.id + '_' + index) !== null) {
                        this.$refs.root
                            .querySelectorAll('#' + this.id + '_' + index)
                            .forEach((el) => {
                                el.checked = true;
                            });
                    }
                    this.simpleFieldSet(index);
                }
            });
        }
    }
};
</script>
